import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';

import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://d1c8beec9d3248999bf0230f738208e6@o351878.ingest.sentry.io/5298507',
  environment: process.env.NODE_ENV,
  // release: packageJson.version,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
